module.exports = __webpack_public_path__ + "img/DiscountCode_Website.4380e0d0.jpg";